import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * 合併 Tailwind CSS 類別名稱
 * 使用 clsx 處理條件類別，使用 tailwind-merge 解決衝突
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}
